/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import "./src/styles/global.css"
import React from "react";
import { ContextApp } from "./src/context/ContextApp";
import { ScrollProvider } from "./src/context/ContextScroll"; 

export const wrapRootElement = ({ element }) => {
  return (
    <ContextApp>
    <ScrollProvider>
        {element}
    </ScrollProvider>
    </ContextApp>
  );
};